import React from 'react';
import { Table, Form, Spinner } from 'react-bootstrap';
import { FaSort, FaSortUp, FaSortDown } from 'react-icons/fa';
import PaginacaoGrid from './PaginacaoGrid';

const thStyle = { cursor: 'pointer', userSelect: 'none', whiteSpace: 'nowrap' };

const iconeSort = (campo, ordenacao) => {
  if (ordenacao.campo !== campo) return <FaSort style={{ opacity: 0.3, marginLeft: 4 }} />;
  return ordenacao.direcao === 'asc'
    ? <FaSortUp style={{ marginLeft: 4 }} />
    : <FaSortDown style={{ marginLeft: 4 }} />;
};

const GridDisponiveis = ({
  contas,
  selecionados,
  onToggle,
  onToggleTodos,
  ordenacao,
  onOrdenar,
  loading,
  paginaAtual,
  totalRegistros,
  itensPorPagina,
  onPaginaChange,
}) => {
  const todosSelecionados = contas.length > 0 && contas.every((c) => selecionados.has(c.codigo_conta));

  if (loading) {
    return (
      <div className="text-center py-3">
        <Spinner animation="border" size="sm" /> Carregando...
      </div>
    );
  }

  if (!contas.length) {
    return <p className="text-muted text-center py-3 mb-0">Nenhuma conta disponível para os filtros informados.</p>;
  }

  return (
    <>
      <Table striped bordered hover size="sm" responsive className="mb-0">
        <thead>
          <tr>
            <th style={{ width: 40 }}>
              <Form.Check
                type="checkbox"
                checked={todosSelecionados}
                onChange={(e) => onToggleTodos(e.target.checked, contas)}
                aria-label="Selecionar todos"
              />
            </th>
            <th style={thStyle} onClick={() => onOrdenar('codigo_conta')}>
              Código {iconeSort('codigo_conta', ordenacao)}
            </th>
            <th style={thStyle} onClick={() => onOrdenar('apelido_conta')}>
              Apelido {iconeSort('apelido_conta', ordenacao)}
            </th>
          </tr>
        </thead>
        <tbody>
          {contas.map((c) => (
            <tr
              key={`${c.codigo_grupo_empresa}-${c.codigo_conta}`}
              style={{ cursor: 'pointer' }}
              onClick={() => onToggle(c.codigo_conta)}
            >
              <td onClick={(e) => e.stopPropagation()}>
                <Form.Check
                  type="checkbox"
                  checked={selecionados.has(c.codigo_conta)}
                  onChange={() => onToggle(c.codigo_conta)}
                  aria-label={`Selecionar conta ${c.codigo_conta}`}
                />
              </td>
              <td>{c.codigo_conta}</td>
              <td>{c.apelido_conta}</td>
            </tr>
          ))}
        </tbody>
      </Table>
      <PaginacaoGrid
        paginaAtual={paginaAtual}
        totalRegistros={totalRegistros}
        itensPorPagina={itensPorPagina}
        onPaginaChange={onPaginaChange}
      />
    </>
  );
};

export default GridDisponiveis;
